import { ApplicationMetadata } from '../../../../dtos/app.dto';
import React from 'react';

export const dependentAppsTooltip = (dependencies: ApplicationMetadata[]) => {
    return <div className="tooltip-content">
        <div className="title">Dependent Apps</div>
        {dependencies.map(dependency => <div key={dependency.id} className="description">{dependency.displayName}</div>)}
    </div>;
};